
document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#table-slider', {
        padding     : { right: '10%' },
        perPage: 1,
        type        : 'loop',
        mediaQuery  : 'min',
        breakpoints : {
            993: {
              destroy: true,
            },
      },
    }).mount();
});


document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#testimonials-slider', {
        type        : 'loop',
        mediaQuery  : 'min',
        breakpoints : {
            993: {
                destroy: true,
            },
      },
    }).mount();
});

document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#testimonials-2-slider', {
        type        : 'loop',
        mediaQuery  : 'min',
        breakpoints : {
            993: {
                destroy: true,
            },
      },
    }).mount();
});

document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#t3-series-slider', {
        width : '70vw',
        padding     : { right: '75%' },
        type        : 'loop',
        breakpoints: {
            991: {
              width: '100%',
              perPage: 1,
              type        : 'loop',
              padding     : { right: '40%' },
            },
        },
  }).mount();
});

document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#discipline-slider', {
        type        : 'loop',
        mediaQuery  : 'min',
        breakpoints : {
            993: {
                destroy: true,
            },
      },
    }).mount();
});
/*MODAL CODE*/
var modals = document.querySelectorAll('[data-modal]');

modals.forEach(function(trigger) {
  trigger.addEventListener('click', function(event) {
    event.preventDefault();
    var modal = document.getElementById(trigger.dataset.modal);
    modal.classList.add('show');
    modal.style.display = "block";

    var exits = modal.querySelectorAll('.close');
    exits.forEach(function(exit) {
      exit.addEventListener('click', function(event) {
        event.preventDefault();
        modal.classList.remove('show');
        modal.style.display = "none";
      });
    });
  });
});
